import { render, staticRenderFns } from "./unsupport.vue?vue&type=template&id=5ff30a18&"
import script from "./unsupport.vue?vue&type=script&lang=js&"
export * from "./unsupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports